import { render } from "./DateInput.vue?vue&type=template&id=2a88b2c0"
import script from "./DateInput.vue?vue&type=script&lang=js"
export * from "./DateInput.vue?vue&type=script&lang=js"
script.render = render

export default script